import { Container } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FC, PropsWithChildren } from 'react';

import { FloatMenu } from '../../FloatMenu';
import { Snackbar } from '../Snackbar';

import styles from './MainLayout.module.scss';

type EmptyLayoutProps = {
  /** Дополнительный класс для содержимого страницы */
  pageContentClassName?: string;
  withFloatMenu?: boolean;
};

export const EmptyLayout: FC<PropsWithChildren<EmptyLayoutProps>> = ({
  pageContentClassName,
  withFloatMenu = true,
  children,
}) => {
  const theme = useTheme();

  return (
    <Container disableGutters maxWidth={false} sx={{ display: 'flex' }} data-theme={theme.palette.mode}>
      <div className={`page-content page-content-noSidebar ${pageContentClassName ?? ''}`}>
        <Snackbar classes={{ containerRoot: styles.snackbarContainerRoot, root: styles.snackbarRoot }} />
        <Container disableGutters maxWidth={false} className="page-container">
          {children}
        </Container>
        {withFloatMenu && <FloatMenu />}
      </div>
    </Container>
  );
};
